<template>
  <div class="qualification">
    <Banner :list="banners"></Banner>
    <div class="qualification-main container">
      <passage></passage>
      <div class="serve">
        <div class="main-title">
          <h1>专业承包资质服务</h1>
          <h3>业务范围覆盖全国 7*24小时无忧服务</h3>
        </div>
        <div class="list">
          <template v-for="(item, index) in childList">
            <div
              :key="index"
              class="item"
              :style="{
                backgroundImage: 'url(' + item.image_url + ')',
                backgroundSize: 'cover',
              }"
            >
              <div class="info">
                <h3>{{ item.name }}</h3>
                <p class="mt-1">{{ item.description }}</p>
              </div>
              <a-button class="btn" @click="$toConnectLink">
                立即咨询>>
              </a-button>
            </div>
          </template>
        </div>
        <div class="m-list">
          <div class="serve-container swiper-container">
            <div class="swiper-wrapper">
              <template
                v-for="(item, index) in Math.floor(childList.length / 6)"
              >
                <div class="swiper-slide" :key="index">
                  <template v-for="(child, idx) in childList">
                    <div
                      :key="idx"
                      v-if="idx >= index * 6 && idx < index * 6 + 6"
                      class="item"
                      :style="{
                        backgroundImage: 'url(' + child.image_url + ')',
                        backgroundSize: 'cover',
                      }"
                    >
                      <div class="info">
                        <h3>{{ child.name }}</h3>
                        <p class="mt-1">{{ child.description }}</p>
                      </div>
                      <a-button class="btn" @click="$toConnectLink">
                        立即咨询>>
                      </a-button>
                    </div>
                  </template>
                </div>
              </template>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
      <connect></connect>
      <div class="required">
        <div class="main-title">
          <h1>办理资质所需材料</h1>
        </div>
        <div class="list">
          <div class="item">
            <div class="img-box">
              <img src="@/assets/image/project/213.png" alt="" />
            </div>
            <div class="info">
              <h3>企业复印件</h3>
              <p>企业营业执照正本，副本彩色 扫描件</p>
              <p>企业营业执照正本，副本彩色 扫描件</p>
              <p>企业章程（含变更）彩色扫描 件</p>
            </div>
          </div>
          <div class="item">
            <div class="img-box">
              <img src="../../assets/image/project/214.png" alt="" />
            </div>
            <div class="info">
              <h3>办公场所证明</h3>
              <p>属于自有产权，房屋产权彩色 扫描件</p>
              <p>属于租赁，房屋租赁合同、使 用证明及房产证彩色扫描件</p>
            </div>
          </div>
          <div class="item">
            <div class="img-box">
              <img src="../../assets/image/project/215.png" alt="" />
            </div>
            <div class="info">
              <h3>人员资料</h3>
              <p>技术工人身份证彩色扫描件</p>
              <p>技术负责人（或注册建造师） 基本情况及业绩</p>
              <p>技术负责人身份证明、职业资 格证书或技能证书</p>
            </div>
          </div>
          <div class="item">
            <div class="img-box">
              <img src="../../assets/image/project/216.png" alt="" />
            </div>
            <div class="info">
              <h3>其他资料</h3>
              <p>标准要求的主要设备购置发票</p>
              <p>经省级注册管理部门批准的 注册建造师初始注册或变更</p>
              <p>注册材料（新企业无资质）</p>
            </div>
          </div>
        </div>
      </div>
      <questions :launch_page="30"></questions>
      <choose></choose>
      <strength></strength>
    </div>
    <message></message>
  </div>
</template>

<script>
import Banner from "@/components/common/banner";
import passage from "@/components/common/passage";
import message from "@/components/common/message";
import choose from "@/components/common/choose";
import strength from "@/components/common/strength";
import connect from "@/components/common/connect";
import questions from "@/components/common/questions";
export default {
  components: {
    Banner,
    passage,
    message,
    choose,
    strength,
    connect,
    questions,
  },
  data() {
    return {
      banners: {
        title: "36项专业承包资质办理",
        desc: "一价全包 无隐藏费用 全过程免费咨询",
        list: [require("@/assets/image/banner/2.jpg")],
      },
      childList: [],
    };
  },
  methods: {
    getBannerList() {
      this.$api
        .getBannerList({
          // 10首页  20
          launchPage: 30,
          launchFacility: 10,
        })
        .then((res) => {
          this.banners.list = res.data.list;
        });
    },
    getCategoryChild() {
      this.$api
        .getCategoryChild({
          pid: 92,
        })
        .then((res) => {
          this.childList = res.data;
          this.$nextTick(() => {
            this.initServeSwiper();
          });
        });
    },
    initServeSwiper() {
      var strenghSwiper = new Swiper(".serve-container", {
        pagination: ".swiper-pagination",
      });
    },
  },
  created() {
    this.getBannerList();
    this.getCategoryChild();
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "HYYaKuHeiW";
  src: url(../../assets/font/HYYaKuHeiW.ttf);
  font-weight: normal;
  font-style: normal;
}
@import "@/assets/css/qualification.scss";
</style>
